import { formFieldNames } from './constants';
import type {
  FormConfigField,
  GenerateFormFunction,
  Form,
  GetValidationFunction,
  ValidationRules,
  GenerateAttrsFunction,
  GenerateInputFunction,
  InputAttrs,
} from './types';
import { publicFieldNames } from '@/components/partials/public-portfolio/constants';

export const generateForm: GenerateFormFunction = ({ fields, user, configuration }) => {
  return fields.reduce((form: Form, field: FormConfigField) => {
    if (field.attributeName === formFieldNames.CITY_ID) {
      form[formFieldNames.CITY_ID] = user?.city?.id;
      return form;
    }

    if (field.attributeName === formFieldNames.COMPANY_ID) {
      form[formFieldNames.COMPANY_ID] = user?.company?.id;
      return form;
    }

    if ((Object.values(publicFieldNames) as string[]).includes(field.attributeName) && configuration) {
      form[field.attributeName] = configuration[field.attributeName];
      return form;
    }

    if (user) form[field.attributeName] = user[field.attributeName];

    return form;
  }, {});
};

export const getValidation: GetValidationFunction = fields => {
  return fields.reduce((acc: Record<string, Partial<ValidationRules>>, field) => {
    if (!field.validation) return acc;

    acc[field.attributeName] = { ...field.validation };

    return acc;
  }, {});
};

const generateInput: GenerateInputFunction = ({ fields, form }) => {
  return fields.reduce((attrs: InputAttrs, field) => {
    if (field.upsertAsInt && form[field.attributeName]) {
      attrs[field.attributeName] = parseInt(form[field.attributeName] as string, 10);
      return attrs;
    }

    if (field.attributeName === formFieldNames.PUBLIC_EMAIL && !form[field.attributeName]) {
      attrs[field.attributeName] = null;
      return attrs;
    }

    attrs[field.attributeName] = form[field.attributeName];

    return attrs;
  }, {});
};

export const generateAttrs: GenerateAttrsFunction = ({ fields, form }) => {
  const configurationFieldNames = Object.values(publicFieldNames);
  const userFields = fields.filter(field => !(configurationFieldNames as string[]).includes(field.attributeName));
  const configurationFields = fields.filter(field =>
    (configurationFieldNames as string[]).includes(field.attributeName),
  );

  return {
    userAttrs: generateInput({ fields: userFields, form }),
    configurationAttrs: generateInput({ fields: configurationFields, form }),
  };
};
